/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HowtoRouteImport } from './routes/howto'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SystemsIndexRouteImport } from './routes/systems/index'
import { Route as StatusPageIndexRouteImport } from './routes/status-page/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SessionsIndexRouteImport } from './routes/sessions/index'
import { Route as RunsIndexRouteImport } from './routes/runs/index'
import { Route as RoutinesIndexRouteImport } from './routes/routines/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as MaintenancePlansIndexRouteImport } from './routes/maintenance-plans/index'
import { Route as DriftIndexRouteImport } from './routes/drift/index'
import { Route as CustomersIndexRouteImport } from './routes/customers/index'
import { Route as SystemsZugangsmigrationRouteImport } from './routes/systems/zugangsmigration'
import { Route as SystemsKernelStatusRouteImport } from './routes/systems/kernel-status'
import { Route as SystemsIdRouteImport } from './routes/systems/$id'
import { Route as SettingsVersionTargetsRouteImport } from './routes/settings/version-targets'
import { Route as SettingsSshConfigRouteImport } from './routes/settings/ssh-config'
import { Route as SettingsServiceTypesRouteImport } from './routes/settings/service-types'
import { Route as SettingsSecretsRouteImport } from './routes/settings/secrets'
import { Route as SettingsMailRouteImport } from './routes/settings/mail'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings/integrations'
import { Route as SettingsImportRouteImport } from './routes/settings/import'
import { Route as SettingsAuditRouteImport } from './routes/settings/audit'
import { Route as RunsRolloutRouteImport } from './routes/runs/rollout'
import { Route as RunsNewRouteImport } from './routes/runs/new'
import { Route as RunsIdRouteImport } from './routes/runs/$id'
import { Route as RoutinesSlugRouteImport } from './routes/routines/$slug'
import { Route as MaintenanceDueRouteImport } from './routes/maintenance/due'
import { Route as InventoryImportRouteImport } from './routes/inventory/import'
import { Route as CustomersIdRouteImport } from './routes/customers/$id'
import { Route as ContractsChangesRouteImport } from './routes/contracts/changes'
import { Route as AiSuggestRouteImport } from './routes/ai/suggest'
import { Route as AiSessionsRouteImport } from './routes/ai/sessions'
import { Route as SettingsContractsMappingRouteImport } from './routes/settings/contracts/mapping'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HowtoRoute = HowtoRouteImport.update({
  id: '/howto',
  path: '/howto',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemsIndexRoute = SystemsIndexRouteImport.update({
  id: '/systems/',
  path: '/systems/',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusPageIndexRoute = StatusPageIndexRouteImport.update({
  id: '/status-page/',
  path: '/status-page/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIndexRoute = SessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsIndexRoute = RunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutinesIndexRoute = RoutinesIndexRouteImport.update({
  id: '/routines/',
  path: '/routines/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenancePlansIndexRoute = MaintenancePlansIndexRouteImport.update({
  id: '/maintenance-plans/',
  path: '/maintenance-plans/',
  getParentRoute: () => rootRouteImport,
} as any)
const DriftIndexRoute = DriftIndexRouteImport.update({
  id: '/drift/',
  path: '/drift/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemsZugangsmigrationRoute = SystemsZugangsmigrationRouteImport.update({
  id: '/systems/zugangsmigration',
  path: '/systems/zugangsmigration',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemsKernelStatusRoute = SystemsKernelStatusRouteImport.update({
  id: '/systems/kernel-status',
  path: '/systems/kernel-status',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemsIdRoute = SystemsIdRouteImport.update({
  id: '/systems/$id',
  path: '/systems/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsVersionTargetsRoute = SettingsVersionTargetsRouteImport.update({
  id: '/settings/version-targets',
  path: '/settings/version-targets',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSshConfigRoute = SettingsSshConfigRouteImport.update({
  id: '/settings/ssh-config',
  path: '/settings/ssh-config',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsServiceTypesRoute = SettingsServiceTypesRouteImport.update({
  id: '/settings/service-types',
  path: '/settings/service-types',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSecretsRoute = SettingsSecretsRouteImport.update({
  id: '/settings/secrets',
  path: '/settings/secrets',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMailRoute = SettingsMailRouteImport.update({
  id: '/settings/mail',
  path: '/settings/mail',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/settings/integrations',
  path: '/settings/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsImportRoute = SettingsImportRouteImport.update({
  id: '/settings/import',
  path: '/settings/import',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAuditRoute = SettingsAuditRouteImport.update({
  id: '/settings/audit',
  path: '/settings/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsRolloutRoute = RunsRolloutRouteImport.update({
  id: '/runs/rollout',
  path: '/runs/rollout',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsNewRoute = RunsNewRouteImport.update({
  id: '/runs/new',
  path: '/runs/new',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsIdRoute = RunsIdRouteImport.update({
  id: '/runs/$id',
  path: '/runs/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutinesSlugRoute = RoutinesSlugRouteImport.update({
  id: '/routines/$slug',
  path: '/routines/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceDueRoute = MaintenanceDueRouteImport.update({
  id: '/maintenance/due',
  path: '/maintenance/due',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryImportRoute = InventoryImportRouteImport.update({
  id: '/inventory/import',
  path: '/inventory/import',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsChangesRoute = ContractsChangesRouteImport.update({
  id: '/contracts/changes',
  path: '/contracts/changes',
  getParentRoute: () => rootRouteImport,
} as any)
const AiSuggestRoute = AiSuggestRouteImport.update({
  id: '/ai/suggest',
  path: '/ai/suggest',
  getParentRoute: () => rootRouteImport,
} as any)
const AiSessionsRoute = AiSessionsRouteImport.update({
  id: '/ai/sessions',
  path: '/ai/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsContractsMappingRoute =
  SettingsContractsMappingRouteImport.update({
    id: '/settings/contracts/mapping',
    path: '/settings/contracts/mapping',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/howto': typeof HowtoRoute
  '/login': typeof LoginRoute
  '/ai/sessions': typeof AiSessionsRoute
  '/ai/suggest': typeof AiSuggestRoute
  '/contracts/changes': typeof ContractsChangesRoute
  '/customers/$id': typeof CustomersIdRoute
  '/inventory/import': typeof InventoryImportRoute
  '/maintenance/due': typeof MaintenanceDueRoute
  '/routines/$slug': typeof RoutinesSlugRoute
  '/runs/$id': typeof RunsIdRoute
  '/runs/new': typeof RunsNewRoute
  '/runs/rollout': typeof RunsRolloutRoute
  '/settings/audit': typeof SettingsAuditRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/mail': typeof SettingsMailRoute
  '/settings/secrets': typeof SettingsSecretsRoute
  '/settings/service-types': typeof SettingsServiceTypesRoute
  '/settings/ssh-config': typeof SettingsSshConfigRoute
  '/settings/version-targets': typeof SettingsVersionTargetsRoute
  '/systems/$id': typeof SystemsIdRoute
  '/systems/kernel-status': typeof SystemsKernelStatusRoute
  '/systems/zugangsmigration': typeof SystemsZugangsmigrationRoute
  '/customers/': typeof CustomersIndexRoute
  '/drift/': typeof DriftIndexRoute
  '/maintenance-plans/': typeof MaintenancePlansIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/routines/': typeof RoutinesIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/status-page/': typeof StatusPageIndexRoute
  '/systems/': typeof SystemsIndexRoute
  '/settings/contracts/mapping': typeof SettingsContractsMappingRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/howto': typeof HowtoRoute
  '/login': typeof LoginRoute
  '/ai/sessions': typeof AiSessionsRoute
  '/ai/suggest': typeof AiSuggestRoute
  '/contracts/changes': typeof ContractsChangesRoute
  '/customers/$id': typeof CustomersIdRoute
  '/inventory/import': typeof InventoryImportRoute
  '/maintenance/due': typeof MaintenanceDueRoute
  '/routines/$slug': typeof RoutinesSlugRoute
  '/runs/$id': typeof RunsIdRoute
  '/runs/new': typeof RunsNewRoute
  '/runs/rollout': typeof RunsRolloutRoute
  '/settings/audit': typeof SettingsAuditRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/mail': typeof SettingsMailRoute
  '/settings/secrets': typeof SettingsSecretsRoute
  '/settings/service-types': typeof SettingsServiceTypesRoute
  '/settings/ssh-config': typeof SettingsSshConfigRoute
  '/settings/version-targets': typeof SettingsVersionTargetsRoute
  '/systems/$id': typeof SystemsIdRoute
  '/systems/kernel-status': typeof SystemsKernelStatusRoute
  '/systems/zugangsmigration': typeof SystemsZugangsmigrationRoute
  '/customers': typeof CustomersIndexRoute
  '/drift': typeof DriftIndexRoute
  '/maintenance-plans': typeof MaintenancePlansIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/routines': typeof RoutinesIndexRoute
  '/runs': typeof RunsIndexRoute
  '/sessions': typeof SessionsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/status-page': typeof StatusPageIndexRoute
  '/systems': typeof SystemsIndexRoute
  '/settings/contracts/mapping': typeof SettingsContractsMappingRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/howto': typeof HowtoRoute
  '/login': typeof LoginRoute
  '/ai/sessions': typeof AiSessionsRoute
  '/ai/suggest': typeof AiSuggestRoute
  '/contracts/changes': typeof ContractsChangesRoute
  '/customers/$id': typeof CustomersIdRoute
  '/inventory/import': typeof InventoryImportRoute
  '/maintenance/due': typeof MaintenanceDueRoute
  '/routines/$slug': typeof RoutinesSlugRoute
  '/runs/$id': typeof RunsIdRoute
  '/runs/new': typeof RunsNewRoute
  '/runs/rollout': typeof RunsRolloutRoute
  '/settings/audit': typeof SettingsAuditRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/mail': typeof SettingsMailRoute
  '/settings/secrets': typeof SettingsSecretsRoute
  '/settings/service-types': typeof SettingsServiceTypesRoute
  '/settings/ssh-config': typeof SettingsSshConfigRoute
  '/settings/version-targets': typeof SettingsVersionTargetsRoute
  '/systems/$id': typeof SystemsIdRoute
  '/systems/kernel-status': typeof SystemsKernelStatusRoute
  '/systems/zugangsmigration': typeof SystemsZugangsmigrationRoute
  '/customers/': typeof CustomersIndexRoute
  '/drift/': typeof DriftIndexRoute
  '/maintenance-plans/': typeof MaintenancePlansIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/routines/': typeof RoutinesIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/status-page/': typeof StatusPageIndexRoute
  '/systems/': typeof SystemsIndexRoute
  '/settings/contracts/mapping': typeof SettingsContractsMappingRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/howto'
    | '/login'
    | '/ai/sessions'
    | '/ai/suggest'
    | '/contracts/changes'
    | '/customers/$id'
    | '/inventory/import'
    | '/maintenance/due'
    | '/routines/$slug'
    | '/runs/$id'
    | '/runs/new'
    | '/runs/rollout'
    | '/settings/audit'
    | '/settings/import'
    | '/settings/integrations'
    | '/settings/mail'
    | '/settings/secrets'
    | '/settings/service-types'
    | '/settings/ssh-config'
    | '/settings/version-targets'
    | '/systems/$id'
    | '/systems/kernel-status'
    | '/systems/zugangsmigration'
    | '/customers/'
    | '/drift/'
    | '/maintenance-plans/'
    | '/notifications/'
    | '/routines/'
    | '/runs/'
    | '/sessions/'
    | '/settings/'
    | '/status-page/'
    | '/systems/'
    | '/settings/contracts/mapping'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/howto'
    | '/login'
    | '/ai/sessions'
    | '/ai/suggest'
    | '/contracts/changes'
    | '/customers/$id'
    | '/inventory/import'
    | '/maintenance/due'
    | '/routines/$slug'
    | '/runs/$id'
    | '/runs/new'
    | '/runs/rollout'
    | '/settings/audit'
    | '/settings/import'
    | '/settings/integrations'
    | '/settings/mail'
    | '/settings/secrets'
    | '/settings/service-types'
    | '/settings/ssh-config'
    | '/settings/version-targets'
    | '/systems/$id'
    | '/systems/kernel-status'
    | '/systems/zugangsmigration'
    | '/customers'
    | '/drift'
    | '/maintenance-plans'
    | '/notifications'
    | '/routines'
    | '/runs'
    | '/sessions'
    | '/settings'
    | '/status-page'
    | '/systems'
    | '/settings/contracts/mapping'
  id:
    | '__root__'
    | '/'
    | '/howto'
    | '/login'
    | '/ai/sessions'
    | '/ai/suggest'
    | '/contracts/changes'
    | '/customers/$id'
    | '/inventory/import'
    | '/maintenance/due'
    | '/routines/$slug'
    | '/runs/$id'
    | '/runs/new'
    | '/runs/rollout'
    | '/settings/audit'
    | '/settings/import'
    | '/settings/integrations'
    | '/settings/mail'
    | '/settings/secrets'
    | '/settings/service-types'
    | '/settings/ssh-config'
    | '/settings/version-targets'
    | '/systems/$id'
    | '/systems/kernel-status'
    | '/systems/zugangsmigration'
    | '/customers/'
    | '/drift/'
    | '/maintenance-plans/'
    | '/notifications/'
    | '/routines/'
    | '/runs/'
    | '/sessions/'
    | '/settings/'
    | '/status-page/'
    | '/systems/'
    | '/settings/contracts/mapping'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HowtoRoute: typeof HowtoRoute
  LoginRoute: typeof LoginRoute
  AiSessionsRoute: typeof AiSessionsRoute
  AiSuggestRoute: typeof AiSuggestRoute
  ContractsChangesRoute: typeof ContractsChangesRoute
  CustomersIdRoute: typeof CustomersIdRoute
  InventoryImportRoute: typeof InventoryImportRoute
  MaintenanceDueRoute: typeof MaintenanceDueRoute
  RoutinesSlugRoute: typeof RoutinesSlugRoute
  RunsIdRoute: typeof RunsIdRoute
  RunsNewRoute: typeof RunsNewRoute
  RunsRolloutRoute: typeof RunsRolloutRoute
  SettingsAuditRoute: typeof SettingsAuditRoute
  SettingsImportRoute: typeof SettingsImportRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsMailRoute: typeof SettingsMailRoute
  SettingsSecretsRoute: typeof SettingsSecretsRoute
  SettingsServiceTypesRoute: typeof SettingsServiceTypesRoute
  SettingsSshConfigRoute: typeof SettingsSshConfigRoute
  SettingsVersionTargetsRoute: typeof SettingsVersionTargetsRoute
  SystemsIdRoute: typeof SystemsIdRoute
  SystemsKernelStatusRoute: typeof SystemsKernelStatusRoute
  SystemsZugangsmigrationRoute: typeof SystemsZugangsmigrationRoute
  CustomersIndexRoute: typeof CustomersIndexRoute
  DriftIndexRoute: typeof DriftIndexRoute
  MaintenancePlansIndexRoute: typeof MaintenancePlansIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  RoutinesIndexRoute: typeof RoutinesIndexRoute
  RunsIndexRoute: typeof RunsIndexRoute
  SessionsIndexRoute: typeof SessionsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  StatusPageIndexRoute: typeof StatusPageIndexRoute
  SystemsIndexRoute: typeof SystemsIndexRoute
  SettingsContractsMappingRoute: typeof SettingsContractsMappingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/howto': {
      id: '/howto'
      path: '/howto'
      fullPath: '/howto'
      preLoaderRoute: typeof HowtoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systems/': {
      id: '/systems/'
      path: '/systems'
      fullPath: '/systems/'
      preLoaderRoute: typeof SystemsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status-page/': {
      id: '/status-page/'
      path: '/status-page'
      fullPath: '/status-page/'
      preLoaderRoute: typeof StatusPageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/': {
      id: '/sessions/'
      path: '/sessions'
      fullPath: '/sessions/'
      preLoaderRoute: typeof SessionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/': {
      id: '/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof RunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routines/': {
      id: '/routines/'
      path: '/routines'
      fullPath: '/routines/'
      preLoaderRoute: typeof RoutinesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance-plans/': {
      id: '/maintenance-plans/'
      path: '/maintenance-plans'
      fullPath: '/maintenance-plans/'
      preLoaderRoute: typeof MaintenancePlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drift/': {
      id: '/drift/'
      path: '/drift'
      fullPath: '/drift/'
      preLoaderRoute: typeof DriftIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/': {
      id: '/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof CustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systems/zugangsmigration': {
      id: '/systems/zugangsmigration'
      path: '/systems/zugangsmigration'
      fullPath: '/systems/zugangsmigration'
      preLoaderRoute: typeof SystemsZugangsmigrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systems/kernel-status': {
      id: '/systems/kernel-status'
      path: '/systems/kernel-status'
      fullPath: '/systems/kernel-status'
      preLoaderRoute: typeof SystemsKernelStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systems/$id': {
      id: '/systems/$id'
      path: '/systems/$id'
      fullPath: '/systems/$id'
      preLoaderRoute: typeof SystemsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/version-targets': {
      id: '/settings/version-targets'
      path: '/settings/version-targets'
      fullPath: '/settings/version-targets'
      preLoaderRoute: typeof SettingsVersionTargetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ssh-config': {
      id: '/settings/ssh-config'
      path: '/settings/ssh-config'
      fullPath: '/settings/ssh-config'
      preLoaderRoute: typeof SettingsSshConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/service-types': {
      id: '/settings/service-types'
      path: '/settings/service-types'
      fullPath: '/settings/service-types'
      preLoaderRoute: typeof SettingsServiceTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/secrets': {
      id: '/settings/secrets'
      path: '/settings/secrets'
      fullPath: '/settings/secrets'
      preLoaderRoute: typeof SettingsSecretsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/mail': {
      id: '/settings/mail'
      path: '/settings/mail'
      fullPath: '/settings/mail'
      preLoaderRoute: typeof SettingsMailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/import': {
      id: '/settings/import'
      path: '/settings/import'
      fullPath: '/settings/import'
      preLoaderRoute: typeof SettingsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/audit': {
      id: '/settings/audit'
      path: '/settings/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof SettingsAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/rollout': {
      id: '/runs/rollout'
      path: '/runs/rollout'
      fullPath: '/runs/rollout'
      preLoaderRoute: typeof RunsRolloutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/new': {
      id: '/runs/new'
      path: '/runs/new'
      fullPath: '/runs/new'
      preLoaderRoute: typeof RunsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/$id': {
      id: '/runs/$id'
      path: '/runs/$id'
      fullPath: '/runs/$id'
      preLoaderRoute: typeof RunsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routines/$slug': {
      id: '/routines/$slug'
      path: '/routines/$slug'
      fullPath: '/routines/$slug'
      preLoaderRoute: typeof RoutinesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance/due': {
      id: '/maintenance/due'
      path: '/maintenance/due'
      fullPath: '/maintenance/due'
      preLoaderRoute: typeof MaintenanceDueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/import': {
      id: '/inventory/import'
      path: '/inventory/import'
      fullPath: '/inventory/import'
      preLoaderRoute: typeof InventoryImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$id': {
      id: '/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts/changes': {
      id: '/contracts/changes'
      path: '/contracts/changes'
      fullPath: '/contracts/changes'
      preLoaderRoute: typeof ContractsChangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai/suggest': {
      id: '/ai/suggest'
      path: '/ai/suggest'
      fullPath: '/ai/suggest'
      preLoaderRoute: typeof AiSuggestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai/sessions': {
      id: '/ai/sessions'
      path: '/ai/sessions'
      fullPath: '/ai/sessions'
      preLoaderRoute: typeof AiSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/contracts/mapping': {
      id: '/settings/contracts/mapping'
      path: '/settings/contracts/mapping'
      fullPath: '/settings/contracts/mapping'
      preLoaderRoute: typeof SettingsContractsMappingRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HowtoRoute: HowtoRoute,
  LoginRoute: LoginRoute,
  AiSessionsRoute: AiSessionsRoute,
  AiSuggestRoute: AiSuggestRoute,
  ContractsChangesRoute: ContractsChangesRoute,
  CustomersIdRoute: CustomersIdRoute,
  InventoryImportRoute: InventoryImportRoute,
  MaintenanceDueRoute: MaintenanceDueRoute,
  RoutinesSlugRoute: RoutinesSlugRoute,
  RunsIdRoute: RunsIdRoute,
  RunsNewRoute: RunsNewRoute,
  RunsRolloutRoute: RunsRolloutRoute,
  SettingsAuditRoute: SettingsAuditRoute,
  SettingsImportRoute: SettingsImportRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsMailRoute: SettingsMailRoute,
  SettingsSecretsRoute: SettingsSecretsRoute,
  SettingsServiceTypesRoute: SettingsServiceTypesRoute,
  SettingsSshConfigRoute: SettingsSshConfigRoute,
  SettingsVersionTargetsRoute: SettingsVersionTargetsRoute,
  SystemsIdRoute: SystemsIdRoute,
  SystemsKernelStatusRoute: SystemsKernelStatusRoute,
  SystemsZugangsmigrationRoute: SystemsZugangsmigrationRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  DriftIndexRoute: DriftIndexRoute,
  MaintenancePlansIndexRoute: MaintenancePlansIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  RoutinesIndexRoute: RoutinesIndexRoute,
  RunsIndexRoute: RunsIndexRoute,
  SessionsIndexRoute: SessionsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  StatusPageIndexRoute: StatusPageIndexRoute,
  SystemsIndexRoute: SystemsIndexRoute,
  SettingsContractsMappingRoute: SettingsContractsMappingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
